import Button from "./Button.component";

export * from "./animations";
export * from "./Button.component";

export default Button;
